export default __webpack_public_path__ + "dist/media/Projects-profile.b618d92e.svg";